import { render } from "./SendInvitation.vue?vue&type=template&id=ecdc4618"
import script from "./SendInvitation.vue?vue&type=script&lang=js"
export * from "./SendInvitation.vue?vue&type=script&lang=js"

import "./SendInvitation.vue?vue&type=style&index=0&id=ecdc4618&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__